var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[_c('div',{staticClass:"h-100",attrs:{"id":"concepts_chart"}}),_c('loader-vue',{attrs:{"visible":_vm.loaderVisible}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }